import React, { useContext, useEffect } from 'react';
import DeliveryAddress from '../delivery/DeliveryAddress';
import TotalsPanel from '../../cart/TotalsPanel';
import DeliveryOptions from '../delivery/DeliveryOptions';
import ContactPanel from '../ContactPanel';
import DeliveryDescription from '../delivery/DeliveryDescription';
import DeliveryNotes from '../delivery/DeliveryNotes';
import IfTrue from '../../../conditions/IfTrue';
import ConfigContext from '../../../../contexts/ConfigContext';
import IfFalse from '../../../conditions/IfFalse';
import CartContext from '../../../../contexts/CartContext';
import { useCustomer } from '../../../../contexts/CustomerContext';

type Props = {
  setNextName: React.Dispatch<React.SetStateAction<string>>;
  setPreNextAction: React.Dispatch<React.SetStateAction<() => () => Promise<boolean>>>;
}

// True iff every field on the address is empty/missing. Used to decide
// whether it's safe to overwrite from the customer's saved default
// without trampling something the user has already typed.
const isAddressBlank = (a: any): boolean => {
  if (!a) return true;
  const fields = ['firstName', 'lastName', 'street', 'additional', 'city', 'province', 'postal'];
  return fields.every((f) => !a[f] || String(a[f]).trim() === '');
};

const Step3 = ({setNextName, setPreNextAction}: Props) => {
  const { cart, setCartState } = useContext(CartContext);
  const { customer } = useCustomer();

  useEffect(() => {
    setPreNextAction(() => async () => {return true});
    setNextName("Next");
    window.scrollTo(0, 0);
  }, []);

  // Auto-fill from saved defaults when arriving on this step — only if the
  // cart's matching address is blank. Runs once when customer becomes
  // available; user edits afterward are preserved.
  useEffect(() => {
    if (!customer) return;
    const patch: any = {};
    if (customer.default_delivery_address && isAddressBlank(cart.deliveryAddress)) {
      patch.deliveryAddress = { ...cart.deliveryAddress, ...customer.default_delivery_address };
    }
    if (customer.default_billing_address && isAddressBlank(cart.cardholderAddress)) {
      patch.cardholderAddress = { ...cart.cardholderAddress, ...customer.default_billing_address };
    }
    if (Object.keys(patch).length > 0) {
      setCartState({ ...cart, ...patch });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.id]);

  const {config} = useContext(ConfigContext);
  const shippingOptions: string[] = config.general.shipping;
  const alwaysVisible = shippingOptions.length === 2;

  return (
    <div className='checkout-parent'>
      <div className='checkout-main'>
        <DeliveryOptions/>
        <DeliveryAddress/>
        <DeliveryDescription/>
        <DeliveryNotes/>
      </div>
      <div className='checkout-right'>
        <TotalsPanel hideDiscount={true} />
        <ContactPanel />
      </div>
    </div>
  )
}

export default Step3